import { Component, OnInit } from '@angular/core';
import { ServicesList } from '../../../lib/servicios.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    imports: [TranslateModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  year: number | undefined;

  serviceList = [
    ServicesList.LATONERIA,
    ServicesList.PORCELANIZADA,
    ServicesList.FIBRA,
    ServicesList.PINTURA,
    ServicesList.PLASTICO,
  ];

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }
}
